import React from 'react';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import Image from 'next/image';
import { imageLoader } from '@/utils/imageLoader';
import { trackEventAPI } from '@/analytics/middleware';
import { TAP_BTN_BRAND_SELECTED } from '@/analytics/events';

const Brands = ({
    brandsData,
    title,
    isCity,
    garage,
    brand,
}: {
    brandsData: any;
    title: string;
    isCity: boolean;
    garage: string;
    brand: string;
}) => {
    const router = useRouter();
    const { city } = router.query;
    const redirectToPage = async (companyName: string) => {
        await trackEventAPI({
            event_name: TAP_BTN_BRAND_SELECTED,
            customAttributes: {
                brand_name: companyName || '',
            },
            isFakeDoor: true,
        });

        let name = companyName.replace(/ /g, '-').toLocaleLowerCase();
        if (isCity) {
            router.push(`/${city}/${name}-service`);
        } else if (brand) {
            if (garage) {
                let garageName = garage.replace(/ /g, '-').toLocaleLowerCase();
                router.push(`/${city}/${name}-service-in-${garageName}`);
            } else {
                router.push(`/${city}/${name}-service`);
            }
        } else if (garage) {
            let garageName = garage.replace(/ /g, '-').toLocaleLowerCase();
            router.push(`/${city}/${name}-service-in-${garageName}`);
        }
    };
    return (
        <BrandsWrapper>
            <BrandHeading dangerouslySetInnerHTML={{ __html: title }} />
            <ImagesContainer>
                {brandsData?.map((brandData: any) => {
                    if (
                        brand.toLocaleLowerCase() ===
                        brandData.company_name.toLocaleLowerCase()
                    ) {
                        return;
                    }
                    return (
                        <LogoContainer
                            onClick={(e) => {
                                e.preventDefault();
                                redirectToPage(brandData.company_name);
                            }}
                            {...((isCity || brand || garage) && {
                                href: isCity
                                    ? `${process.env.NEXT_PUBLIC_ENV_PREFIX}/${city}/${brandData.company_name?.replace(/ /g, '-').toLocaleLowerCase()}-service`
                                    : brand
                                      ? garage
                                          ? `${process.env.NEXT_PUBLIC_ENV_PREFIX}/${city}/${brandData.company_name?.replace(/ /g, '-').toLocaleLowerCase()}-service-in-${garage.replace(/ /g, '-').toLocaleLowerCase()}`
                                          : `${process.env.NEXT_PUBLIC_ENV_PREFIX}/${city}/${brandData.company_name?.replace(/ /g, '-').toLocaleLowerCase()}-service`
                                      : `${process.env.NEXT_PUBLIC_ENV_PREFIX}/${city}/${brandData?.company_name?.replace(/ /g, '-')?.toLocaleLowerCase()}-service-in-${garage?.replace(/ /g, '-')?.toLocaleLowerCase()}`,
                            })}
                        >
                            <Image
                                loader={imageLoader}
                                src={
                                    brandData?.company_image_url?.data
                                        ?.attributes?.url
                                }
                                width={52}
                                height={36}
                            />
                        </LogoContainer>
                    );
                })}
            </ImagesContainer>
        </BrandsWrapper>
    );
};

export default Brands;

const BrandsWrapper = styled.div`
    display: flex;
    padding: 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    align-self: stretch;
    background: linear-gradient(132deg, #ebdefa 2.2%, #facbdb 85.4%);
`;

const BrandHeading = styled.h2`
    color: #000;
    font-family: 'Euclid Circular B';
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
    letter-spacing: -0.1px;
    margin: 0;
`;

const ImagesContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: flex-start;
    width: 100%;
`;

const LogoContainer = styled.a`
    display: flex;
    padding: 6px 10px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    background: #fff;
`;
